import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ENTERPRISE_CONTROL_BASE } from "./constants";

const NAV = [
  { to: ENTERPRISE_CONTROL_BASE, label: "Dashboard", exact: true },
  { to: `${ENTERPRISE_CONTROL_BASE}/organizations`, label: "Organizations" },
  { to: `${ENTERPRISE_CONTROL_BASE}/licenses`, label: "License management" },
  { to: `${ENTERPRISE_CONTROL_BASE}/audit`, label: "Audit & activity" },
];

const EnterpriseControlSubnav = () => {
  const { pathname } = useLocation();
  const inEnterprise =
    pathname === ENTERPRISE_CONTROL_BASE || pathname.startsWith(`${ENTERPRISE_CONTROL_BASE}/`);

  if (!inEnterprise) return null;

  const isActive = (item) => {
    if (item.exact) return pathname === item.to;
    return pathname === item.to || pathname.startsWith(`${item.to}/`);
  };

  return (
    <div className="mb-6 space-y-2">
      <p className="text-xs font-semibold uppercase tracking-wide text-[#6b6280]">Nyafaz Enterprise</p>
      <div className="flex flex-wrap items-center gap-2 pb-3 border-b border-[#e8e0ef]">
        {NAV.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`text-sm font-semibold px-3 py-1.5 rounded-lg ${
              isActive(item) ? "bg-[#2d5a7b] text-white" : "text-[#5a516c] hover:bg-[#f4f8fb]"
            }`}
          >
            {item.label}
          </Link>
        ))}
        <Link to="/nyafaz-portal/home" className="text-sm text-[#2d5a7b] font-semibold ml-auto hover:underline">
          ← Overview
        </Link>
      </div>
    </div>
  );
};

export default EnterpriseControlSubnav;
